import React from 'react'

const LockOpenIcon = ({color = 'currentColor', width = 20, height = 20, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <g clipPath="url(#clip0_lockopen)">
            <path
                d="M15.0007 6.66732H14.1673V5.00065C14.1673 2.70065 12.3007 0.833984 10.0007 0.833984C7.70065 0.833984 5.83398 2.70065 5.83398 5.00065H7.50065C7.50065 3.61732 8.61732 2.50065 10.0007 2.50065C11.384 2.50065 12.5007 3.61732 12.5007 5.00065V6.66732H5.00065C4.08398 6.66732 3.33398 7.41732 3.33398 8.33398V16.6673C3.33398 17.584 4.08398 18.334 5.00065 18.334H15.0007C15.9173 18.334 16.6673 17.584 16.6673 16.6673V8.33398C16.6673 7.41732 15.9173 6.66732 15.0007 6.66732ZM15.0007 16.6673H5.00065V8.33398H15.0007V16.6673ZM10.0007 14.1673C10.9173 14.1673 11.6673 13.4173 11.6673 12.5007C11.6673 11.584 10.9173 10.834 10.0007 10.834C9.08398 10.834 8.33398 11.584 8.33398 12.5007C8.33398 13.4173 9.08398 14.1673 10.0007 14.1673Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_lockopen">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default LockOpenIcon
